"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var cms_integration_1 = require("@idp/cms-integration");
var ui_components_1 = require("@idp/ui-components");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var Utils = require("../../../utils/UtilityFunctions");
var MonthlySavingsPanelState_1 = require("./MonthlySavingsPanelState");
var styles = require("./MonthlySavingsPanel.scss");
var ReportingService_1 = require("../../../api/ReportingService");
var Cart_cms_1 = require("../../../cms/Cart.cms");
var icons = require("../../../styles/ccc-icons-cart.scss");
var CartConfiguration_scss_1 = require("../../CartConfigurationContainer/CartConfiguration.scss");
// const mockMonthlySavingsResponse = require('../../../config/mock_data/monthlySavings.json');
var MonthlySavingsPanel = /** @class */ (function (_super) {
    __extends(MonthlySavingsPanel, _super);
    function MonthlySavingsPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.state = new MonthlySavingsPanelState_1.default();
        _this.reportingService = new ReportingService_1.default();
        return _this;
    }
    MonthlySavingsPanel.prototype.onMonthlySavingsModalClose = function () {
        this.props.close();
    };
    MonthlySavingsPanel.prototype.render = function () {
        var _a;
        var totalSavingsAmt = this.props.totalSavingAmt ? this.props.totalSavingAmt : 0;
        this.monthlySavingsCmsTexts = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content.common.monthlySavingsPanel;
        return (React.createElement(ui_components_1.Modal, { testId: "Modal_Monthly_Savings_Details", options: { className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn }, show: true,
                showClose: true,
                size: ModalProps_1.ModalSizes.SMALL }, events: { onClose: this.onMonthlySavingsModalClose.bind(this) }, accessibilityText: "_Monthly_Savings_Details" },
            React.createElement("div", { className: styles.modalSpacing },
                React.createElement("div", { className: styles.modalTitle },
                    React.createElement("span", null, this.monthlySavingsCmsTexts.moreLinesMoreSavings)),
                React.createElement("div", { className: styles.goodNews }, this.monthlySavingsCmsTexts.monthlyPricesLabel ?
                    this.monthlySavingsCmsTexts.monthlyPricesLabel.replace('{0}', (_a = Utils.amountWithDecimal(totalSavingsAmt, 2, '$')) === null || _a === void 0 ? void 0 : _a.toString()) : ''),
                React.createElement("table", { className: styles.tableContainer },
                    React.createElement("tbody", null,
                        React.createElement("tr", { className: styles.tableHeader },
                            React.createElement("th", null, this.monthlySavingsCmsTexts.tableHeaderForLine),
                            React.createElement("th", null, this.monthlySavingsCmsTexts.tableHeaderForCurrentPrice),
                            React.createElement("th", null, this.monthlySavingsCmsTexts.tableHeaderForNewPrice)),
                        this.props.monthlySavings && this.props.monthlySavings.content &&
                            this.props.monthlySavings.content.payload &&
                            this.props.monthlySavings.content.payload.planPrice &&
                            this.props.monthlySavings.content.payload.planPrice.map(function (line, index) {
                                if (line.type === 'EXISTING_LINE') {
                                    return (React.createElement("tr", { className: styles.tableBody, key: line.ctn },
                                        React.createElement("td", null, line.ctn),
                                        React.createElement("td", null,
                                            "$",
                                            line.currentPrice),
                                        React.createElement("td", null,
                                            "$",
                                            line.newPrice)));
                                }
                                else if (line.type === 'NEW_LINE') {
                                    var iconClasses = [icons.cccIconCart, icons.cccIconCartLg,
                                        icons.cccIconCartNew, styles.newIcon];
                                    var nickName = (line.subscriberName && line.subscriberName.firstName) ?
                                        line.subscriberName.firstName + "'s Plan" : "Line " + (index + 1);
                                    return (React.createElement("tr", { className: styles.tableBody },
                                        React.createElement("td", { className: styles.planPadding },
                                            React.createElement("span", null, nickName),
                                            React.createElement("span", null,
                                                React.createElement("i", { className: iconClasses.join(' '), role: "img" }))),
                                        React.createElement("td", { className: styles.planPadding }),
                                        React.createElement("td", { className: styles.planPadding },
                                            "$",
                                            line.newPrice)));
                                }
                                return (React.createElement(React.Fragment, null));
                            }),
                        this.props.monthlySavings && this.props.monthlySavings.content &&
                            this.props.monthlySavings.content.payload &&
                            this.props.monthlySavings.content.payload.planPriceSummary &&
                            React.createElement("tr", { className: styles.subTotalsRow },
                                React.createElement("td", null, this.monthlySavingsCmsTexts.subTotals),
                                React.createElement("td", null,
                                    "$",
                                    this.props.monthlySavings.content.payload.
                                        planPriceSummary.existingPlanMrcTotal),
                                React.createElement("td", null,
                                    "$",
                                    this.props.monthlySavings.content.payload.
                                        planPriceSummary.newPlanMrcTotal)))),
                React.createElement("div", { className: styles.monthlyPricesLegalText },
                    React.createElement("span", null, this.monthlySavingsCmsTexts.monthlyPrices)),
                React.createElement("div", { className: styles.reservedLinesLegalText },
                    React.createElement("span", null, this.monthlySavingsCmsTexts.pricingLegal)))));
    };
    return MonthlySavingsPanel;
}(React.Component));
exports.default = MonthlySavingsPanel;
//# sourceMappingURL=MonthlySavingsPanel.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/MonthlySavingsPanel/MonthlySavingsPanel.js
// module id = 764
// module chunks = 8